import React from 'react';

import { getPursuitImageUrl } from 'libs/styleHelpers';

import { Loader } from 'components/ui/Loader';

import { colors, Fonts, spacing } from 'styles/theme';
import {
    Bumper,
    HorizontalFlexWrapper,
    RadioButton,
    RadioLoaderWrapper,
    RadioSelectIcon,
} from 'styles/shared';

export interface IconRadioItem {
    key: string;
    label: string;
    sublabel?: string;
}

interface IconRadioProps {
    items: Array<IconRadioItem>;
    onSelectItem: (key: string) => () => void;
    selectedKey: string;
    loadingKey: string;
}

export const IconRadio = ({
    items,
    onSelectItem,
    selectedKey,
    loadingKey,
}: IconRadioProps) => (
    <>
        {items.map(({ key, label, sublabel }, index) => {
            const isSelected = selectedKey === key;
            return (
                <>
                    <Bumper />
                    <HorizontalFlexWrapper key={key}>
                        <RadioButton
                            onClick={onSelectItem(key)}
                            $isSelected={isSelected}
                        >
                            {loadingKey === key ? (
                                <RadioLoaderWrapper>
                                    <Loader $color={colors.grandGreen} />
                                </RadioLoaderWrapper>
                            ) : (
                                <RadioSelectIcon
                                    $isSelected={isSelected}
                                    $imageUrl={getPursuitImageUrl(index) ?? ''}
                                />
                            )}
                        </RadioButton>
                        <div>
                            <HorizontalFlexWrapper>
                                <Fonts.Medium $isOpenSansSemiBold>
                                    {label}
                                </Fonts.Medium>
                            </HorizontalFlexWrapper>

                            <Bumper $minHeight={spacing.xxxSmall} />
                            <Fonts.MediumQuote>{sublabel}</Fonts.MediumQuote>
                        </div>
                    </HorizontalFlexWrapper>
                </>
            );
        })}
    </>
);
